import { render, staticRenderFns } from "./Mcn.vue?vue&type=template&id=5bdd7a29&scoped=true"
import script from "./Mcn.vue?vue&type=script&lang=js"
export * from "./Mcn.vue?vue&type=script&lang=js"
import style0 from "./Mcn.vue?vue&type=style&index=0&id=5bdd7a29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdd7a29",
  null
  
)

export default component.exports